module.exports = __webpack_public_path__ + "assets/46f2e63893e67f7d4d7e37f6d11cd50b.mp3";